import SpecializationPage from "@/components/SpecializationPage";
import { IMG } from "@/lib/images";

export default function RivestimentiProtettivi() {
  return (
    <SpecializationPage
      testid="rivestimenti-protettivi-page"
      quoteService="Rivestimenti protettivi anticorrosivi"
      index="/ 11"
      title="Rivestimenti Protettivi Anticorrosivi"
      lines={["Rivestimenti", "protettivi."]}
      subtitle="Protezione conservativa e anticorrosiva delle superfici tramite spruzzatura a fiamma di polveri termoplastiche: un film continuo ad altissima durata."
      image={IMG.steel}
      accent="Barriera anticorrosione, per sempre."
      intro={[
        "La spruzzatura a fiamma applica polveri termoplastiche che, fondendo, formano un rivestimento continuo, compatto e privo di porosità. Il film protettivo isola completamente il substrato dall'aggressione di acqua, sali, agenti atmosferici e sostanze chimiche.",
        "È la soluzione ideale per proteggere e conservare strutture metalliche e superfici esposte alla corrosione, prolungandone drasticamente la vita utile e riducendo i costi di manutenzione.",
      ]}
      specs={[
        { k: "Tecnologia", v: "Flame spray" },
        { k: "Film", v: "Continuo, senza pori" },
        { k: "Resistenza corrosione", v: "Elevata" },
        { k: "Resistenza chimica", v: "Elevata" },
        { k: "Aderenza", v: "Ottima su metalli" },
        { k: "Manutenzione", v: "Ridotta" },
      ]}
      benefits={[
        { t: "Anticorrosione", d: "Barriera totale contro ruggine, ossidazione e agenti aggressivi." },
        { t: "Protezione conservativa", d: "Preserva strutture e manufatti nel tempo, prolungandone la vita utile." },
        { t: "Film continuo", d: "Rivestimento compatto e senza giunzioni, privo di punti deboli." },
        { t: "Resistenza chimica", d: "Inattaccabile da sali, acidi e ambienti industriali e marini." },
        { t: "Massima aderenza", d: "Perfetto ancoraggio su acciaio, ferro e leghe metalliche." },
        { t: "Meno manutenzione", d: "Riduce interventi e costi di ripristino nel tempo." },
      ]}
      applications={[
        "Strutture metalliche e carpenteria",
        "Serbatoi e cisterne",
        "Tubazioni e condotte",
        "Ringhiere, cancellate e recinzioni",
        "Coperture e lamiere metalliche",
        "Travi, pilastri e telai in acciaio",
        "Passerelle e grigliati industriali",
        "Silos e tramogge",
        "Scale e soppalchi metallici",
        "Elementi in ferro e leghe",
        "Elementi zincati e da verniciare",
        "Impianti, macchinari e valvole",
        "Ambienti industriali",
        "Ambienti marini e costieri",
        "Parapetti e balaustre",
        "Elementi di arredo urbano",
      ]}
      faqs={[
        { q: "Come protegge dalla corrosione la spruzzatura a fiamma?", a: "Le polveri termoplastiche, fondendo, formano un film continuo, compatto e privo di porosità che isola completamente il substrato dall'acqua, dai sali e dagli agenti aggressivi, bloccando ruggine e ossidazione." },
        { q: "Su quali materiali si può applicare?", a: "Principalmente su acciaio, ferro e leghe metalliche: carpenteria, serbatoi, tubazioni, ringhiere, coperture metalliche, travi, silos e molti altri manufatti." },
        { q: "È adatto ad ambienti marini o industriali?", a: "Sì. Il rivestimento resiste ad ambienti aggressivi come quelli marini, costieri e industriali, dove la corrosione è particolarmente severa." },
        { q: "Riduce i costi di manutenzione?", a: "Sì. Proteggendo in modo conservativo le strutture, prolunga notevolmente la loro vita utile e riduce la frequenza e i costi degli interventi di ripristino." },
      ]}
    />
  );
}
